/**
 * useActivation — read-only Northstar activation state hook.
 *
 * There is no writer. The backend is the sole source of truth and the
 * only path that flips `activated` is a real Buddy connection
 * acceptance inside `/api/buddy/connections/{id}` — this hook cannot
 * grant Northstar access from the client under any circumstance.
 */
import { useEffect, useState, useCallback } from "react";
import { api } from "../lib/auth";

export function useActivation({ enabled = true } = {}) {
  const [state, setState] = useState({
    loading: enabled,
    error: null,
    data: null,
  });

  const refresh = useCallback(async () => {
    setState((s) => ({ ...s, loading: true, error: null }));
    try {
      const r = await api.get("/northstar/activation");
      setState({ loading: false, error: null, data: r.data });
    } catch (err) {
      setState({ loading: false, error: err, data: null });
    }
  }, []);

  useEffect(() => {
    if (!enabled) return;
    refresh();
  }, [enabled, refresh]);

  return { ...state, refresh };
}
